import * as zod from 'zod';

const FIELD_NAME = 'nickname';
const NICKNAME_REGEX = /^[0-9a-zA-Zа-яА-ЯёЁіІїЇєЄӘҒҚҢӨҰҮҺәғқңөұүһ_]*$/;
const NICKNAME_MIN_SYMBOLS = 2;

const NICKNAME_ERRORS = {
  PROFILE_USERNAME_TOO_SHORT: 'PROFILE_USERNAME_TOO_SHORT',
  PROFILE_USERNAME_TOO_LONG: 'PROFILE_USERNAME_TOO_LONG',
  PROFILE_USE_NOT_ALLOWED_CHARACTERS: 'PROFILE_USE_NOT_ALLOWED_CHARACTERS',
  PROFILE_USERNAME_ALREADY_EXISTS: 'PROFILE_USERNAME_ALREADY_EXISTS'
};

const nicknameSchema = zod.object({
  [FIELD_NAME]: zod
    .string()
    .regex(NICKNAME_REGEX, NICKNAME_ERRORS.PROFILE_USE_NOT_ALLOWED_CHARACTERS)
    .min(NICKNAME_MIN_SYMBOLS, NICKNAME_ERRORS.PROFILE_USERNAME_TOO_SHORT)
}).required();

export {
  FIELD_NAME,
  NICKNAME_REGEX,
  NICKNAME_MIN_SYMBOLS,
  NICKNAME_ERRORS,
  nicknameSchema
};
